import { ApiBase } from "./ApiBase";
import { BaseMedia } from "typings/media";

export class MediaAPI extends ApiBase
{
    async createFolder(name: string, parentId?: string): Promise<BaseMedia>
    {
        const body = new FormData();
        body.append("folderName", name);
        if (parentId)
        {
            body.append("parentId", parentId);
        }
        const response = await this.fetch("frontend/media",
        {
            body,
            method: "PUT",
        });
       
        return response.json();
    }

    async uploadYoutube(url: string, parentId: string): Promise<{ content: BaseMedia }>
    {
        const body = new FormData();
        body.append("url", url);
        const response = await this.fetch(`frontend/media/${(parentId || "")}/youtube`, {
            body, method: "PUT"
        });
        return response.json();
    }

    async uploadFiles(files: File[], parentId: string): Promise<{ assets: BaseMedia[], invalidFiles: string[] }>
    {
        const body = new FormData();
        files.forEach(element => body.append("files", element));

        const response = await this.fetch(`frontend/media/${(parentId || "")}`, {
            body, method: "PUT"
        });
        return response.json();
    }

    async getMedia(id?: string) : Promise<BaseMedia[]>
    {
        const response = await this.fetch(`frontend/media/${(id || "")}`,
        {
            method: "GET"
        });
        return response.json();
    }

    async loadMultipleMedia(ids: string[]): Promise<BaseMedia[]>
    {
        const response = await this.fetch(`frontend/media/byIds`,
        {
            body: JSON.stringify(ids),
            method: "POST",
            headers: 
            {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        });
        return response.json();
    }

    async updateMedia(id: string, update: { [key: string]: string} ) : Promise<void>
    {
        await this.fetch(`frontend/media/${(id || "")}`,
        {
            body: JSON.stringify(update),
            method: "POST",
            headers: 
            {
                "Accept": "application/json",
                "Content-Type": "application/json"
            }
        });
    }

    async delete(id: string) : Promise<void>
    {
        await this.fetch(`frontend/media/${(id || "")}`,
        {
            method: "DELETE"
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/media.ts